export default __webpack_public_path__ + "static/media/contactsPicture.c1999ebc.png";